import { getCommonWidget } from "../../dashWidgetHelper";
import {
  PRODUTURO_PIE_COLORS, PRODUTURO_SCALE_5_COLORS, commonWidgets, getProfuturoAtencion,
  getProfuturoNpsAcumulado, getProfuturoNpsPorMes, getProfuturoSatisfaccion, getProfuturoNpsConsar, getProfuturoCustomerJourney,
  getNpsPorEjecutivoTable
}
  from "../commonWidgetsProfuturo";

export default {
  title: 'Acompañamiento Dashboard',
  description: 'Acompañamiento Dashboard',
  backgroundClassName: (filters: FiltersUI) => 'epsilon-hero-bg',
  widgets: (filters: FiltersUI) => [
    {
      title: 'Principales Indicadores',
      size: [4, 1],
      type: 'label',
      config: { color: '#B7AADC' },
    },
    getProfuturoNpsAcumulado({
      size: [1, 2],
      indicator: 'sucursal_pregunta_22'
    }),
    getProfuturoNpsPorMes({
      size: [1, 2],
      indicator: 'sucursal_pregunta_22'
    }),

    getProfuturoSatisfaccion({
      size: [1, 2],
      indicator: 'sucursal_pregunta_2',
      helpText: '¿Qué tan satisfecho estás con tu visita a la oficina?'
    }),

    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'countNumberSemicircle',
      title: 'Satisfacción tiempo de espera',
      size: [1, 2],
      indicator: 'sucursal_pregunta_4',
      helpText: '¿Qué tan satisfecho estás con el tiempo de espera para ser atendido?',
      historic: {
        type: 'line',
        formula: "wavg",
        formulaConfig: "avgmax-10"
      }
    }),
    getProfuturoAtencion({
      size: [1, 2],
      indicator: 'sucursal_pregunta_9',
      helpText: 'Ahora vamos a hablar del asesor que te atendió en tu última visita a la sucursal, ¿cómo fue tu experiencia?'
    }),
    getProfuturoNpsConsar({
      indicator: 'sucursal_pregunta_26',
      size: [1, 2],
      title: 'NPS CONSAR',
      helpText: '¿Qué tan probable es que recomiendes el servicio de la oficina con amigos y/o familiares?'
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'countNumberSemicircle',
      title: 'Experiencia de espera',
      helpText: '¿Cómo calificarías tu experiencia durante la espera antes de pasar a un módulo de atención?',
      size: [1, 2],
      indicator: 'sucursal_pregunta_31'
    }),
    {
      title: 'Motivadores y quiebres',
      size: [4, 1],
      type: 'label',
      config: { color: '#B7AADC' },
    },
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'pieGenericMedium',
      title: 'Satisfacción: clientes insatisfechos',
      size: [2, 2],
      indicator: 'sucursal_pregunta_3',
      helpText: 'Señalaste que estás insatisfecho con la visita, ¿nos puedes contar por qué?',
      extraConfigs: {
        colors: PRODUTURO_PIE_COLORS,
      }
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'pieGenericMedium',
      title: 'Atención: clientes insatisfechos',
      helpText: 'Señalaste que estás insatisfecho con la atención del asesor, ¿nos puedes contar por qué?  ',
      size: [2, 2],
      indicator: 'sucursal_pregunta_10',
      extraConfigs: {
        colors: PRODUTURO_PIE_COLORS,
      }
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'pieGenericMediumSiNo',
      title: 'Resolución del Trámite',
      helpText: ' En tu última visita, ¿Se resolvió tu trámite?',
      size: [2, 2],
      indicator: 'sucursal_pregunta_27',
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'pieGenericMedium',
      title: 'Visitas Concluido el trámite',
      helpText: '¿Cuántas veces acudiste a Sucursal para concluir tu trámite?',
      size: [2, 2],
      indicator: 'sucursal_pregunta_28',
      extraConfigs: {
        colors: PRODUTURO_SCALE_5_COLORS,
      }
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'pieGenericMedium',
      title: 'Visitas Sin concluir el trámite',
      helpText: '¿Cuántas veces has acudido para darle seguimiento a tu trámite?',
      size: [2, 2],
      indicator: 'sucursal_pregunta_29',
      extraConfigs: {
        colors: PRODUTURO_SCALE_5_COLORS,
      }
    }),

    {
      title: 'Atributos de experiencia',
      size: [4, 1],
      type: 'label',
    },
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'stackedBar',
      title: 'La amabilidad y calidez con la que me atendió',
      helpText: 'Pensando en la atención recibida, ¿qué tan satisfecho estás con cada uno de los siguientes aspectos?',
      size: [4, 1],
      indicator: 'sucursal_pregunta_12',
      extraConfigs: {
        colorMapping: {
          'Muy satisfecho': '#006400',
          'Nada satisfecho': '#8B0000'
        }
      }
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'stackedBar',
      title: 'Los conocimientos y claridad acerca de la solicitud / trámite.',
      helpText: 'Pensando en la atención recibida, ¿qué tan satisfecho estás con cada uno de los siguientes aspectos?',
      size: [4, 1],
      indicator: 'sucursal_pregunta_13',
      extraConfigs: {
        colorMapping: {
          'Muy satisfecho': '#006400',
          'Nada satisfecho': '#8B0000'
        }
      }
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'stackedBar',
      title: 'El compromiso e interés que se mostró para resolver mi petición.',
      helpText: 'Pensando en la atención recibida, ¿qué tan satisfecho estás con cada uno de los siguientes aspectos?',
      size: [4, 1],
      indicator: 'sucursal_pregunta_14',
      extraConfigs: {
        colorMapping: {
          'Muy satisfecho': '#006400',
          'Nada satisfecho': '#8B0000'
        }
      }
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'stackedBar',
      title: 'La asesoría que me dieron (orientación) para que tomara una decisión informada.',
      helpText: 'Pensando en la atención recibida, ¿qué tan satisfecho estás con cada uno de los siguientes aspectos?',
      size: [4, 1],
      indicator: 'sucursal_pregunta_15',
      extraConfigs: {
        colorMapping: {
          'Muy satisfecho': '#006400',
          'Nada satisfecho': '#8B0000'
        }
      }
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'stackedBar',
      title: 'La imagen del asesor refleja profesionalismo.',
      helpText: 'Pensando en la atención recibida, ¿qué tan satisfecho estás con cada uno de los siguientes aspectos?',
      size: [4, 1],
      indicator: 'sucursal_pregunta_16',
      extraConfigs: {
        colorMapping: {
          'Muy satisfecho': '#006400',
          'Nada satisfecho': '#8B0000'
        }
      }
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'stackedBar',
      title: 'La ubicación de la sucursal.',
      helpText: 'Pensando en la atención recibida, ¿qué tan satisfecho estás con cada uno de los siguientes aspectos?',
      size: [4, 1],
      indicator: 'sucursal_pregunta_18',
      extraConfigs: {
        colorMapping: {
          'Muy satisfecho': '#006400',
          'Nada satisfecho': '#8B0000'
        }
      }
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'stackedBar',
      title: 'Las instalaciones de la sucursal (limpieza, espacio, temperatura)',
      helpText: 'Pensando en la atención recibida, ¿qué tan satisfecho estás con cada uno de los siguientes aspectos?',
      size: [4, 1],
      indicator: 'sucursal_pregunta_19',
      extraConfigs: {
        colorMapping: {
          'Muy satisfecho': '#006400',
          'Nada satisfecho': '#8B0000'
        }
      }
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'stackedBar',
      title: 'El tiempo en que se llevó a cabo mi trámite / consulta.',
      helpText: 'Pensando en la atención recibida, ¿qué tan satisfecho estás con cada uno de los siguientes aspectos?',
      size: [4, 1],
      indicator: 'sucursal_pregunta_20',
      extraConfigs: {
        colorMapping: {
          'Muy satisfecho': '#006400',
          'Nada satisfecho': '#8B0000'
        }
      }
    }),

    {
      title: 'Atributos de experiencia en el tiempo de espera',
      size: [4, 1],
      type: 'label',
    },
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'stackedBar',
      title: 'La claridad de la información que recibí al llegar a la oficina sobre el trámite a realizar',
      helpText: 'Mientras esperabas tu turno para pasar a un módulo con un asesor, ¿ qué tan satisfecho estás con los siguientes aspectos?',
      size: [4, 1],
      indicator: 'sucursal_pregunta_32',
      extraConfigs: {
        colorMapping: {
          'Muy satisfecho': '#006400',
          'Nada satisfecho': '#8B0000'
        }
      }
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'stackedBar',
      title: 'El acompañamiento del personal durante la espera para resolver dudas o prevenir contratiempos.',
      helpText: 'Mientras esperabas tu turno para pasar a un módulo con un asesor, ¿ qué tan satisfecho estás con los siguientes aspectos?',
      size: [4, 1],
      indicator: 'sucursal_pregunta_33',
      extraConfigs: {
        colorMapping: {
          'Muy satisfecho': '#006400',
          'Nada satisfecho': '#8B0000'
        }
      }
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'stackedBar',
      title: 'El acceso al Wi-Fi durante la espera.',
      helpText: 'Mientras esperabas tu turno para pasar a un módulo con un asesor, ¿ qué tan satisfecho estás con los siguientes aspectos?',
      size: [4, 1],
      indicator: 'sucursal_pregunta_35',
      extraConfigs: {
        colorMapping: {
          'Muy satisfecho': '#006400',
          'Nada satisfecho': '#8B0000'
        }
      }
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'wordCount',
      title: 'Sugerencias y comentarios',
      size: [4, 2],
      helpText: '¿Hay alguna sugerencia o comentario que nos quieras realizar sobre tu visita a la oficina?',
      indicator: 'sucursal_pregunta_30'
    }),
    getProfuturoCustomerJourney({
      id: 'cj-sucursal',
      title: 'Customer Journey: Top Two Box',
      size: [4, 2],
      indicators: [
        { name: 'sucursal_pregunta_2', formula: 'count-number' },
        { name: 'sucursal_pregunta_20', formula: 'count-number' },
        { name: 'sucursal_pregunta_9', formula: 'count-number' },
        { name: 'sucursal_pregunta_22', formula: 'nps-10' },
      ],
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'textAnalysis',
      title: 'Análisis de Sentimientos',
      size: [4, 4],
      indicator: 'SENTIMENT'
    }),


    getNpsPorEjecutivoTable({
      size: [4, 2],
      criticalMomentInclude: [13604]
    })

  ]
} as DasboardConfig
